<template>
  <div id="app">
    <!-- 头部 -->
    <HeaderTopView v-bind:num="num" @childFn="parentFn($event)"></HeaderTopView>
    <HeaderView></HeaderView>
    <NavView></NavView>
    <!-- 内容 -->
    <div class="content">
      <section class="banner_div word">
        <div class="topmsg">
          <div class="img">
           <img :src="$img+msg.frontCover" alt="" />
          </div>
          <div class="words">
            <h3 class="font1 title1">{{$t('aboutUS.briefintroduction')}}</h3>
            <h4 class="font2">{{msg.synopsis}}</h4>
            <h4 class="font3 content">“{{msg.idea}}”    -{{$t('aboutUS.idea')}}</h4>
			 <h4 class="font3">{{$t('aboutUS.Mainbusiness')}}</h4>
            <h3 class="font2 content2">{{msg.mainBusiness}}</h3>
            <h4 class="font2">{{msg.products}}</h4>
          </div>
        </div>
        <div class="bottom-msg">
          <h3 class="font1 b-title1">{{$t('aboutUS.purpose')}}</h3>
          <h4 class="font2">{{msg.ourPurpose}}</h4>
          <div class="bottom-box">
            <div class="img-box" v-for="(item,index) in msg.imageText">
              <div class="i">
                <img :src="$img+item.img" alt="">
              </div>
              <h4 class="font2">{{item.des}}</h4>
            </div>
          </div>
        </div>
      </section>
    </div>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>


<script>
	import HeaderTopView from '@/components/assembly/HeaderTop.vue'; //头部模块
	import HeaderView from '@/components/assembly/Header.vue'; //头部模块
	import NavView from '@/components/assembly/Nav.vue'; //导航模块
	import Footer from '@/components/assembly/Footer.vue'; //导航模块
	export default {
		name: "AboutUs",
		data() {
			return {
				num: '1',
				msg:{}
			}
		},
		components: {
			HeaderView,
			NavView,
			HeaderTopView,
			Footer
		},
		methods: {
			parentFn(payload) {
				console.log('登录' + payload)
			},
			getMsg() {
				let url = '/open/news/information/we/about'
				this.$get(url).then(res => {
					if (res.code == 0) {
						res.data.imageText = JSON.parse(res.data.imageText)
						this.msg = res.data
					}
				})
			}
		},
		mounted() {
			this.getMsg()
		}
	}
</script>

<style scoped>
	.content {
		background: #F4F4F4;
		padding: 22px 0;
	}

	.img {
		width: 483px;
		height: 398px;
		margin-right: 47px;
	}

	img {
		display: block;
		width: 100%;
		height: 100%;
	}

	.topmsg {
		display: flex;
		justify-content: space-between;
	}

	.words {
		width: 653px;
	}

	.font1 {
		font-size: 20px;
		text-align: left;
	}

	.title1 {
		margin-bottom: 23px;
	}

	.font2 {
		font-size: 14px;
		color: #777;
		text-align: left;
	}

	.font3 {
		font-size: 14px;
		color: #333;
		font-weight: bold;
		text-align: left;
	}

	.words .content {
		margin: 30px 0;
	}

	.words .content2 {
		margin: 19px 0 55px 0;
	}

	.bottom-msg {
		margin-top: 63px;
	}

	.b-title1 {
		margin-bottom: 25px;
	}

	.bottom-box {
		display: flex;
		justify-content: space-between;
		margin-top: 34px;
	}

	.img-box {
		width: 390px;
	}

	.i {
		width: 390px;
		height: 313px;
		margin-bottom: 17px;
	}
</style>



// WEBPACK FOOTER //
// src/components/aboutUs/AboutUs.vue